import { t } from "i18next";
import * as React from "react";
import {
  AddButton,
  ButtonsContainer,
  CancelButton,
} from "../addClientModal/addClientModal.styles";
import { Patch, Post, handleError } from "../../../utils/fetch.util";
import { UserContext } from "../../../contexts/user.context";
import { toast } from "react-toastify";

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  getAllItems: () => void;
  editVacationRequestType: any;
  setEditVacationRequestType: React.Dispatch<any>;
}

interface VacationRequestType {
  name_en: string;
  name_ar: string;
}

const AddEditVacationRequestTypeModal: React.FC<Props> = ({
  open,
  setOpen,
  setEditVacationRequestType,
  editVacationRequestType,
  getAllItems,
}) => {
  const defaultVacationRequestType = {
    name_en: "",
    name_ar: "",
  };
  const [vacationRequestType, setVacationRequestType] =
    React.useState<VacationRequestType>(defaultVacationRequestType);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const { getValidToken } = React.useContext(UserContext);

  const handleAdd = async (e: any) => {
    e.preventDefault();
    const res = await Post(
      "vacation-request-type/add-vacation-request-type",
      vacationRequestType,
      getValidToken(),
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }

    toast.success("Successfully Added");
    setVacationRequestType(defaultVacationRequestType);
    setIsLoading(false);
    getAllItems();
    setOpen(false);
  };

  const handleEdit = async (e: any) => {
    e.preventDefault();

    const res = await Patch(
      "vacation-request-type/update-vacation-request-type",
      { ...vacationRequestType, type_id: editVacationRequestType.id },
      getValidToken(),
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }

    toast.success("Successfully Edited");
    setVacationRequestType(defaultVacationRequestType);
    setIsLoading(false);
    getAllItems();
    setOpen(false);
    setEditVacationRequestType(null);
  };

  React.useEffect(() => {
    editVacationRequestType &&
      setVacationRequestType({
        name_en: editVacationRequestType.name_en,
        name_ar: editVacationRequestType.name_ar,
      });
  }, [editVacationRequestType]);

  return (
    <>
      <div
        className={`toggle_server_model fixed top-0 left-0 w-full h-full bg-[#00000075] flex items-center justify-center !z-[99999] ${
          open ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="fixed top-0 left-0 w-full h-[100vh] cursor-pointer"
          onClick={() => {
            setOpen(false);
            setVacationRequestType(defaultVacationRequestType);
            setEditVacationRequestType(null);
          }}
        ></div>
        <form
          className={`bg-white w-full max-w-[500px] p-6 relative z-[9999] max-h-[90vh] overflow-x-auto rounded-lg`}
          onSubmit={editVacationRequestType ? handleEdit : handleAdd}
        >
          <h2 className="text-3xl mb-6 !text-black">
            {t(
              editVacationRequestType
                ? "edit_vacation_request_type"
                : "add_vacation_request_type",
            )}
          </h2>
          <div className="flex flex-col gap-2 mt-5">
            <label aria-required>{t("name_en")}</label>
            <input
              onChange={(e) =>
                setVacationRequestType((prev) => {
                  return { ...prev, name_en: e.target.value };
                })
              }
              value={vacationRequestType.name_en}
              name="title"
              className="border"
              type="text"
              required
            />
          </div>
          <div className="flex flex-col gap-2 mt-5">
            <label aria-required>{t("name_ar")}</label>
            <input
              onChange={(e) =>
                setVacationRequestType((prev) => {
                  return { ...prev, name_ar: e.target.value };
                })
              }
              value={vacationRequestType.name_ar}
              name="title"
              className="border"
              type="text"
              required
            />
          </div>
          <ButtonsContainer style={{ gap: "2rem" }}>
            <AddButton isLoading={isLoading} type="submit">
              {t("submit")}
            </AddButton>
            <CancelButton
              type="button"
              style={{ border: "2px solid black" }}
              onClick={() => {
                setOpen(false);
                setVacationRequestType(defaultVacationRequestType);
                setEditVacationRequestType(null);
              }}
            >
              {t("cancelBtn")}
            </CancelButton>
          </ButtonsContainer>
        </form>
      </div>
    </>
  );
};

export default AddEditVacationRequestTypeModal;
